import { Typography, Box, Container, Link, Grid } from "@mui/material";

const Hero = () => {
  return (
    <Box
      sx={{
        overflow: "hidden",
        mt: "100px",
        position: "top",
        // backgroundImage: "data:image/jpeg;base64,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",
        backgroundImage: `url('https://iagility.com/bubble-mobile.6bac0c0278fd05a17632.png')`,
        backgroundSize: "50%", //"auto 300%", // Or 'contain' based on your need
        backgroundPosition: " right -15% bottom 35%;",
        // background-position-x: "75%",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container maxWidth="xl" sx={{ p: "0px 10px" }} id="home">
        <Grid container justifyContent="center" sx={{ height: "600px", pb: 5 }}>
          <Box
            component="picture"
            sx={{ width: "100%", maxWidth: "100%", p: "calc(1.5rem * .5)" }}
          >
            {/* Image sources for different formats */}
            <Box
              component="img"
              src="https://iagility.com/assets/images/Union-3.png"
              alt="circle dots"
              sx={{
                position: "absolute",
                left: "-650px",
                top: "70px",
                width: "600px",
                height: "600px",
                zIndex: -1,
              }}
            />
          </Box>
          <Grid
            item
            xs={12}
            md={8}
            lg={7}
            sx={{ textAlign: ["center", "left"], zIndex: 100 }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 700,
                fontSize: "28px",
                color: "rgb(13, 15, 89)",
              }}
            ></Typography>

            <Typography
              variant="h1"
              sx={{
                lineHeight: 1.2,
                fontWeight: 700,
                fontSize: "54px",
                color: "rgb(128, 110, 60)",
              }}
            >
              Anti Money Laundering (AML) compliance Solution
              <span style={{ color: "rgb(46, 125, 50)" }}> </span>
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{ fontSize: "28px", color: "rgb(13, 15, 89)" }}
            >
              Global PEP and Sanction Screening
            </Typography>
            <Typography
              sx={{
                mt: 0,
                mb: 1,
                pt: "12px",
                fontSize: "18px",
                color: "rgb(85, 87, 90)",
                pb: "15px",
              }}
            >
              Offload Your AML-CFT Worries – Elevate Your Business!
            </Typography>
            <Link
              href="mailto:info@amldiligence.com"
              sx={{
                display: "block",
                backgroundColor: "#D0051A",
                color: "white",
                borderRadius: "50px",
                boxShadow: "rgba(245, 61, 76, 0.3) 0px 10px 25px 0px",
                p: "10px 30px",
                textAlign: "center",
                textDecoration: "none",
                // height: "45px",
                width: "15Vw",
                lineHeight: "25px",
              }}
            >
              Request Details
            </Link>
          </Grid>
          <RightColumnContent />
          {/* Additional Grid items for right column content */}
        </Grid>
      </Container>
    </Box>
  );
};

const RightColumnContent = () => {
  return (
    <>
      <Grid
        item
        xs={12}
        md={10}
        lg={5}
        sx={{ position: "relative", zIndex: 100 }}
      >
        {/* Cards Container */}
        <Grid container justifyContent="center" spacing={2}>
          {/* User Card */}
          <Grid item>
            {/* Insert your SVG here */}
            <svg
              width="855.41839"
              // height="610.77534"
              height="480"
              viewBox="0 0 855.41839 610.77534"
            >
              <path
                d="M466.82588,165.95293H421.689a1.59353,1.59353,0,1,1,0-3.187h45.13692a1.59353,1.59353,0,0,1,0,3.187Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#806e3c"
              />
              <path
                d="M466.82588,177.23755H421.689a1.59353,1.59353,0,1,1,0-3.187h45.13692a1.59353,1.59353,0,0,1,0,3.187Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#806e3c"
              />
              <path
                d="M466.82588,188.52139H421.689a1.59353,1.59353,0,1,1,0-3.187h45.13692a1.59353,1.59353,0,0,1,0,3.187Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#806e3c"
              />
              <path
                d="M466.82588,199.806H421.689a1.59353,1.59353,0,1,1,0-3.187h45.13692a1.59353,1.59353,0,0,1,0,3.187Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#806e3c"
              />
              <path
                d="M466.82588,211.09063H421.689a1.59353,1.59353,0,1,1,0-3.18706h45.13692a1.59353,1.59353,0,0,1,0,3.18706Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#806e3c"
              />
              <path
                d="M707.317,280.59077a3.19065,3.19065,0,0,1,3.187,3.187v69.06255a3.19066,3.19066,0,0,1-3.187,3.187H639.665a3.19066,3.19066,0,0,1-3.187-3.187V283.77782a3.19065,3.19065,0,0,1,3.187-3.187h67.652m0-3.187H639.665a6.3741,6.3741,0,0,0-6.3741,6.3741v69.06255a6.3741,6.3741,0,0,0,6.3741,6.3741h67.652a6.37411,6.37411,0,0,0,6.3741-6.3741V283.77782a6.3741,6.3741,0,0,0-6.3741-6.3741Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#806e3c"
              />
              <path
                d="M696.76476,298.74432H651.62784a1.59353,1.59353,0,1,1,0-3.187h45.13692a1.59353,1.59353,0,0,1,0,3.187Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#806e3c"
              />
              <path
                d="M696.76476,310.02894H651.62784a1.59353,1.59353,0,0,1,0-3.18706h45.13692a1.59353,1.59353,0,0,1,0,3.18706Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#806e3c"
              />
              <path
                d="M696.76476,321.31278H651.62784a1.59352,1.59352,0,1,1,0-3.187h45.13692a1.59353,1.59353,0,0,1,0,3.187Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#806e3c"
              />
              <path
                d="M696.76476,332.59739H651.62784a1.59353,1.59353,0,1,1,0-3.187h45.13692a1.59353,1.59353,0,0,1,0,3.187Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#806e3c"
              />
              <path
                d="M696.76476,343.882H651.62784a1.59353,1.59353,0,1,1,0-3.187h45.13692a1.59353,1.59353,0,0,1,0,3.187Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#806e3c"
              />
              <path
                d="M362.73282,226.42308H293.30943a7.08972,7.08972,0,0,1-7.08139-7.08138V169.66541a7.08988,7.08988,0,0,1,7.08139-7.08216h69.42339a7.09,7.09,0,0,1,7.08217,7.08216V219.3417A7.08988,7.08988,0,0,1,362.73282,226.42308ZM293.30943,165.7703a3.89917,3.89917,0,0,0-3.89434,3.89511V219.3417a3.89851,3.89851,0,0,0,3.89434,3.89433h69.42339a3.89917,3.89917,0,0,0,3.89511-3.89433V169.66541a3.89983,3.89983,0,0,0-3.89511-3.89511Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#e6e6e6"
              />
              <path
                d="M350.59,184.81246H305.45305a1.59353,1.59353,0,0,1,0-3.187H350.59a1.59353,1.59353,0,1,1,0,3.187Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#806e3c"
              />
              <path
                d="M350.59,196.09708H305.45305a1.59353,1.59353,0,0,1,0-3.187H350.59a1.59353,1.59353,0,1,1,0,3.187Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#806e3c"
              />
              <path
                d="M350.59,207.38092H305.45305a1.59353,1.59353,0,0,1,0-3.187H350.59a1.59353,1.59353,0,1,1,0,3.187Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#806e3c"
              />
              <path
                d="M593.09111,253.95025,526.41486,234.6141a7.08971,7.08971,0,0,1-4.82882-8.77351l13.83608-47.71054a7.08988,7.08988,0,0,1,8.77372-4.82958l66.67625,19.33615a7.09,7.09,0,0,1,4.82935,8.77447l-13.83608,47.71055A7.08988,7.08988,0,0,1,593.09111,253.95025Zm-49.78294-77.58884a3.89916,3.89916,0,0,0-4.82511,2.65631L524.647,226.72827a3.89851,3.89851,0,0,0,2.65557,4.8249l66.67624,19.33614a3.89918,3.89918,0,0,0,4.82565-2.65535l13.83608-47.71054a3.89985,3.89985,0,0,0-2.65609-4.82587Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#e6e6e6"
              />
              <path
                d="M593.01835,210.60411l-43.3508-12.57175a1.59353,1.59353,0,0,1,.88767-3.06094L593.906,207.54318a1.59352,1.59352,0,1,1-.88768,3.06093Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#806e3c"
              />
              <path
                d="M589.87531,221.44219,546.5245,208.87043a1.59352,1.59352,0,1,1,.88767-3.06093L590.763,218.38125a1.59353,1.59353,0,0,1-.88767,3.06094Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#806e3c"
              />
              <path
                d="M586.73248,232.27951l-43.35081-12.57175a1.59353,1.59353,0,0,1,.88767-3.06094l43.35081,12.57176a1.59352,1.59352,0,0,1-.88767,3.06093Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#806e3c"
              />
              <rect
                x="156.10589"
                y="607.77534"
                width="699.3125"
                height="3"
                fill="#e6e6e6"
              />
              <polygon
                points="562.14 603.085 448.421 603.085 452.276 552.973 558.285 552.973 562.14 603.085"
                fill="#e6e6e6"
              />
              <rect
                x="442.63878"
                y="597.3034"
                width="127.21043"
                height="11.5646"
                fill="#e6e6e6"
              />
              <path
                d="M895.37073,374.74021H460.73514a11.56458,11.56458,0,0,0-11.56458,11.56458h0V651.3265H906.93533V386.30479a11.56457,11.56457,0,0,0-11.56456-11.56458Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#3f3d56"
              />
              <path
                d="M449.17056,651.3265v43.36719a11.56457,11.56457,0,0,0,11.56458,11.56457H895.37073a11.56459,11.56459,0,0,0,11.5646-11.56457h0V651.3265Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#e6e6e6"
              />
              <rect
                x="300.00891"
                y="254.22076"
                width="412.47016"
                height="231.29169"
                fill="#e6e6e6"
              />
              <circle cx="506.244" cy="533.69821" r="11.56459" fill="#3f3d56" />
              <circle cx="312.86987" cy="261.79534" r="2.19466" fill="#fff" />
              <circle cx="321.20026" cy="261.79534" r="2.19466" fill="#fff" />
              <circle cx="329.53064" cy="261.79534" r="2.19466" fill="#fff" />
              <rect
                x="310.6752"
                y="269.25275"
                width="389.91608"
                height="194.24707"
                fill="#fff"
              />
              <path
                d="M508.885,443.41111a1.37973,1.37973,0,0,0-1.37842,1.37842v69.67578a1.37973,1.37973,0,0,0,1.37842,1.37841H589.3493a1.37973,1.37973,0,0,0,1.37842-1.37841V444.78953a1.37973,1.37973,0,0,0-1.37842-1.37842Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#e6e6e6"
              />
              <path
                d="M638.08075,443.63523a1.37984,1.37984,0,0,0-1.37891,1.37842v69.45166a1.37984,1.37984,0,0,0,1.37891,1.37841h80.208a1.37963,1.37963,0,0,0,1.37793-1.37841V445.01365a1.37963,1.37963,0,0,0-1.37793-1.37842Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#e6e6e6"
              />
              <path
                d="M765.92157,442.9072a1.37963,1.37963,0,0,0-1.37793,1.37842v70.17969a1.37962,1.37962,0,0,0,1.37793,1.37841h81.042a1.37962,1.37962,0,0,0,1.37793-1.37841V444.28562a1.37963,1.37963,0,0,0-1.37793-1.37842Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#e6e6e6"
              />
              <path
                d="M510.35614,550.333a2.84986,2.84986,0,0,0,0,5.69971h75.65234a2.84986,2.84986,0,0,0,0-5.69971Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#e6e6e6"
              />
              <path
                d="M510.35614,563.88865a2.8501,2.8501,0,0,0,0,5.70019h34.062a2.8501,2.8501,0,0,0,0-5.70019Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#806e3c"
              />
              <path
                d="M640.94012,550.333a2.84986,2.84986,0,0,0,0,5.69971h75.65235a2.84986,2.84986,0,0,0,0-5.69971Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#e6e6e6"
              />
              <path
                d="M640.94012,563.88865a2.8501,2.8501,0,0,0,0,5.70019h34.0625a2.8501,2.8501,0,0,0,0-5.70019Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#806e3c"
              />
              <path
                d="M768.26044,550.333a2.84986,2.84986,0,0,0,0,5.69971h75.65234a2.84986,2.84986,0,0,0,0-5.69971Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#e6e6e6"
              />
              <path
                d="M510.35614,536.333a2.84986,2.84986,0,0,0,0,5.69971h75.65234a2.84986,2.84986,0,0,0,0-5.69971Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#e6e6e6"
              />
              <path
                d="M640.94012,536.333a2.84986,2.84986,0,0,0,0,5.69971h75.65235a2.84986,2.84986,0,0,0,0-5.69971Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#e6e6e6"
              />
              <path
                d="M768.26044,536.333a2.84986,2.84986,0,0,0,0,5.69971h75.65234a2.84986,2.84986,0,0,0,0-5.69971Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#e6e6e6"
              />
              <path
                d="M768.26044,563.88865a2.8501,2.8501,0,0,0,0,5.70019H802.322a2.8501,2.8501,0,0,0,0-5.70019Z"
                transform="translate(-172.29081 -144.61233)"
                fill="#806e3c"
              />{" "}
            </svg>{" "}
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{ position: "relative", zIndex: 100 }}
          spacing={5}
        ></Grid>
      </Grid>
    </>
  );
};

export default Hero;
